import React from 'react'
import { navigateTo } from 'gatsby-link'

import SymbolAtlas from '../container/SymbolAtlas'
import SymbolLegend from '../components/SymbolLegend'
import Popup_10_14 from '../components/Popup_10_14.js'
import YearChange_10_14 from '../components/YearChange_10_14'
import Quelle from '../components/Quelle.js'

import symbols_facility_10_14 from '../data/symbols_facility_10_14.js'
import bezirke from '../data/bezirke'

class Betreuungseinrichtungen_10_14 extends React.Component {
  clickOnGemeinde = iso => {
    const bezirk = bezirke.find(b => b.filter(iso))
    if (bezirk.zoomToIso === this.props.pathContext.zoomToIso) {
      this.openPopup(iso)
    } else {
      this.setZoomToIso(bezirk.zoomToIso)
    }
  }

  setZoomToIso = (iso = 0) => {
    const path = this.props.data.allSite.edges.find(
      e =>
        e.node.fields &&
        e.node.fields.zoomToIso === iso &&
        e.node.fields.showPopup === false
    ).node.path
    navigateTo(path)
  }

  closePopup = () => {
    const path = this.props.data.allSite.edges.find(
      e =>
        e.node.fields &&
        e.node.fields.zoomToIso === this.props.pathContext.zoomToIso &&
        e.node.fields.showPopup === false
    ).node.path
    navigateTo(path)
  }

  openPopup = iso => {
    const path = this.props.data.allSite.edges.find(
      e =>
        e.node.fields &&
        e.node.fields.popup === Number(iso) &&
        e.node.fields.showPopup === true
    ).node.path
    navigateTo(path)
  }

  render() {
    const symbolData = this.props.data.alleGemeinden.edges.map(gemeinde => {
      const Nmbetr = this.props.data.allNmbetr.edges.find(
        nmbetr => nmbetr.node.GemCode == gemeinde.node.iso
      ) || { node: {} }

      return { node: { ...gemeinde.node, ...Nmbetr.node } }
    })

    return (
      <div className="content-box">
        <h2>
          Betreuungseinrichtungen <YearChange_10_14 />
        </h2>
        {this.props.pathContext.showPopup ? (
          <Popup_10_14
            data={this.props.data}
            openPopup={this.openPopup}
            closePopup={this.closePopup}
          />
        ) : null}
        <div style={{ breakAfter: false }}>
          <SymbolLegend
            symbols={symbols_facility_10_14}
            label={`${this.props.pathContext.name
              ? `Bezirk ${this.props.pathContext.name}`
              : 'Burgenland'}`}
          />
          <div className="content-map-div">
            <SymbolAtlas
              data={symbolData}
              symbols={symbols_facility_10_14}
              zoomToIso={this.props.pathContext.zoomToIso}
              setZoomToIso={this.setZoomToIso}
              clickOnGemeinde={this.clickOnGemeinde}
            />
          </div>
        </div>
        {/* <Quelle></Quelle> */}
      </div>
    )
  }
}

export default Betreuungseinrichtungen_10_14

export const query = graphql`
  query facilities_10_14($popup: Int!) {
    alleGemeinden: allGemeinden201819Json {
      edges {
        node {
          iso
          name
        }
      }
    }
    allSite: allSitePage(
      filter: { path: { regex: "/Betreuung_10_14/Betreuungseinrichtungen/" } }
    ) {
      edges {
        node {
          path
          fields {
            title
            zoomToIso
            popup
            showPopup
          }
        }
      }
    }
    allNmbetr: allNmbetr1014201920Json {
      edges {
        node {
          id
          GemCode
          NMS_getrennt
          NMS_verschr
          NMS_nein
          ASO_getrennt
          AHS_ja
          AHS_nein
          poly_ja
          poly_nein
        }
      }
    }
    gemeinde: gemeinden201819Json(iso: { eq: $popup }) {
      iso
      name
    }
    zusatzGemeinden: allGemeindenZusatzinfosJson(
      filter: { Code_2015: { eq: $popup } }
    ) {
      edges {
        node {
          Website_Gemeinde
          Telefon_Gemeinde
          Zusatzinfo
        }
      }
    }
    Nmbetr: allNmbetr1014201920Json(filter: { GemCode: { eq: $popup } }) {
      edges {
        node {
          GemCode
          NMS_getrennt
          NMS_verschr
          NMS_nein
          ASO_getrennt
          AHS_ja
          AHS_nein
          poly_ja
          poly_nein
        }
      }
    }
    NmbetrInfo: allNmbetr1014Info201920Json(
      filter: { GemCode: { eq: $popup } }
    ) {
      edges {
        node {
          id
          GemCode
          BezCode
          SKZ
          Schulart
          Typ
          Nachmittagsbetreuung
          Nachmittagsbetreuung_Form
          Schule
          Adresse
          Telefonnummer
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/facilities_10_14.js